import { useNavigate } from '@tanstack/react-location'
import React, { useMemo } from 'react'
import Button from 'shared/components/Button'
import { smartSort } from 'shared/helpers/arrays'

function RoomDesignsTable({ data = [], onItemClick, onAdd }) {
  const rooms = useMemo(
    (acc, item) => {
      return data.reduce((acc, item) => {
        acc[item.room.id] = acc[item.room.id] || []
        acc[item.room.id] = item.room
        return acc
      }, {})
    },
    [data],
  )

  const grouped = useMemo(() => {
    const grouped = data.reduce((acc, item) => {
      acc[item.room.id] = acc[item.room.id] || []
      acc[item.room.id].push(item)
      return acc
    }, {})
    return grouped
  }, [data])

  const maxRoomsLength = Math.max(0, ...Object.values(grouped).map((i) => i.length))

  return (
    <div>
      <div className="my-[16px] flex items-center justify-between">
        <div className="font-medium opacity-70">Room Designs</div>
        <div className="flex items-center">
          <Button size="small" className="ml-[16px] first:ml-[0]" variant="secondary" rounded onClick={onAdd}>
            Add room design
          </Button>
        </div>
      </div>
      <div className="data-table mt-[16px]">
        <table className="table table-fixed w-full">
          <thead>
            <tr>
              {Object.values(rooms)
                .sort(smartSort('room_classification.weight', 'desc'))
                .map((i, index) => (
                  <th key={index} className="px-4 py-2">
                    {i.name}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody>
            {Array(maxRoomsLength)
              .fill()
              .map((_d, index) => (
                <tr key={index}>
                  {Object.values(rooms)
                    .sort(smartSort('room_classification.weight', 'desc'))
                    .map((i) => grouped[i.id][index])
                    .map((i) => (
                      <td
                        key={index}
                        className={`px-4 py-2  ${i ? 'hover:bg-[#E8EAF0]' : 'pointer-events-none cursor-default'}`}
                        onClick={() => {
                          onItemClick(i)
                        }}
                      >
                        {i ? `${i.room.name} by ${i.main_vendor.full_name}` : ''}
                      </td>
                    ))}
                </tr>
              ))}
          </tbody>
        </table>
        {/* {data.length === 0 && <div className="p-[16px] text-sm font-normal opacity-70">{emptyLabel}</div>} */}
      </div>
    </div>
  )
}

export default RoomDesignsTable
